import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import TLinkButton from '~/components/atoms/t-link-button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogSignUpHeader',
  setup(__props) {

const { $isFlagOn } = useContext();

return { __sfc: true,$isFlagOn, TLinkButton }
}

})